module.exports = __webpack_public_path__ + "img/lzlyzng.0deb14f3.jpg";